import { QueryClient } from '@tanstack/react-query';

import { cartKey } from '@lib/api/options/cart';
import AppError from '@lib/app-error';
import { CART_ERROR_CODE } from '@lib/types';

export const refreshCartOnUnavailableOffer = async (
  queryClient: QueryClient,
  error: unknown,
) => {
  if (
    !(error instanceof AppError) ||
    error.code !== CART_ERROR_CODE.OFFER_UNAVAILABLE
  ) {
    return false;
  }

  queryClient.invalidateQueries({ queryKey: cartKey }).catch(() => undefined);

  return true;
};
